/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Gyms_Equipment_CountInputs */

const en_us2_gyms_equipment_count = /** @type {(inputs: Gyms_Equipment_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 piece of equipment`);
	return /** @type {LocalizedString} */ (`${i?.count} pieces of equipment`)
	
};

const pt_br2_gyms_equipment_count = /** @type {(inputs: Gyms_Equipment_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 equipamento`);
	return /** @type {LocalizedString} */ (`${i?.count} equipamentos`)
	
};

const es_419_gyms_equipment_count = /** @type {(inputs: Gyms_Equipment_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 equipo`);
	return /** @type {LocalizedString} */ (`${i?.count} equipos`)
	
};

const pt_pt2_gyms_equipment_count = /** @type {(inputs: Gyms_Equipment_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 equipamento`);
	return /** @type {LocalizedString} */ (`${i?.count} equipamentos`)
	
};

const fr_fr2_gyms_equipment_count = /** @type {(inputs: Gyms_Equipment_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 équipement`);
	return /** @type {LocalizedString} */ (`${i?.count} équipements`)
	
};

const de_de2_gyms_equipment_count = /** @type {(inputs: Gyms_Equipment_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 Gerät`);
	return /** @type {LocalizedString} */ (`${i?.count} Geräte`)
	
};

const it_it2_gyms_equipment_count = /** @type {(inputs: Gyms_Equipment_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 attrezzo`);
	return /** @type {LocalizedString} */ (`${i?.count} attrezzi`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "1 piece of equipment" |
* | * | "{count} pieces of equipment" |
*
* @param {Gyms_Equipment_CountInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const gyms_equipment_count = /** @type {((inputs: Gyms_Equipment_CountInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gyms_Equipment_CountInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_gyms_equipment_count(inputs)
	if (locale === "es-419") return es_419_gyms_equipment_count(inputs)
	if (locale === "pt-PT") return pt_pt2_gyms_equipment_count(inputs)
	if (locale === "fr-FR") return fr_fr2_gyms_equipment_count(inputs)
	if (locale === "de-DE") return de_de2_gyms_equipment_count(inputs)
	if (locale === "it-IT") return it_it2_gyms_equipment_count(inputs)
	return en_us2_gyms_equipment_count(inputs)
});
export { gyms_equipment_count as "gyms.equipment_count" }